import { render } from "./informationIndex.vue?vue&type=template&id=839635ec&scoped=true"
import script from "./informationIndex.vue?vue&type=script&lang=js"
export * from "./informationIndex.vue?vue&type=script&lang=js"

import "./informationIndex.vue?vue&type=style&index=0&id=839635ec&lang=scss&scoped=true"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-839635ec"]])

export default __exports__